import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CambiarEmisionPage } from './cambiar-emision.component';
import { authGuard } from '@guards/auth.guard';
import { hasRoleGuard } from '@guards/has-role.guard';

const routes: Routes = [
  {
    path: 'cambiar-emision',
    component: CambiarEmisionPage,
    canActivate: [authGuard, hasRoleGuard(null, ['rfc_cambiar_emision'])],
    data: {
      title: "Cambio de emisión"
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class CambiarEmisionPageRoutingModule { }
